import React from 'react'
import { Table } from "reactstrap"
import { EstadoPlanificacionConSolicitud, PlanificacionSolicitudVacaciones } from './TypesSolicitudVacaciones'



type PropsTablePlanificaciones = {
    planificacionesDelAnio: PlanificacionSolicitudVacaciones[],
    celdaCheck: (p: PlanificacionSolicitudVacaciones) => JSX.Element;
    anio: number,
    showColumnSeleccionar?: boolean
}

export default function TablePlanificaciones(props: PropsTablePlanificaciones) {

    const { planificacionesDelAnio, celdaCheck, anio } = props;

    return (
        <React.Fragment>
            <div className="rows_tabla_planificacion_vacaciones_anio">
                <p className="mb-0">{`Planificación ${anio}`}</p>
            </div>
            <Table bordered className="table_planificacion_vacaciones" >
                <thead className="cabeceras_tabla_planificacion_vac">
                    <tr className="borde_cabeceras_planificacion" >
                        <th colSpan={1}>Desde </th>
                        <th colSpan={1}>Hasta</th>
                        <th colSpan={1}>{"Días Ordinarios"}</th>
                        {( (props.showColumnSeleccionar !== undefined && props.showColumnSeleccionar) || props.showColumnSeleccionar === undefined) &&  <th colSpan={1}>{"Seleccione"}</th> }
                        <th colSpan={1}>{"Estado"}</th>
                    </tr>
                </thead>
                {
                    planificacionesDelAnio.map((plAnio, indplAnio) => {
                        return (
                            <tbody key={"tbodyplanificacionAnio " + indplAnio}>
                                <tr className="rows_tabla_planificacion_vac_directivo">
                                    <td className="celdaFechaSPVacaciones">
                                        {plAnio.fechaInicioString}


                                    </td>
                                    <td className="celdaFechaSPVacaciones">
                                        {plAnio.fechaFinString}


                                    </td>
                                    <td>{plAnio.diasOrdinarios}</td>

                                    {(props.showColumnSeleccionar !== undefined && props.showColumnSeleccionar || props.showColumnSeleccionar === undefined) &&
                                        <td>
                                            {celdaCheck(plAnio)}
                                        </td>
                                    }




                                    <td className={plAnio.estadoParse === EstadoPlanificacionConSolicitud.NO_EJECUTADO ? "bold" : ""}> {plAnio.estadoParse}</td>
                                </tr>
                            </tbody>
                        )
                    })

                }
            </Table>
        </React.Fragment>

    )
}
